var React = require('react');

function TwitterB (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23 1.01009C22.0424 1.68768 20.9821 2.20594 19.86 2.54489C19.2577 1.85023 18.4573 1.35787 17.567 1.1344C16.6767 0.910937 15.7395 0.967149 14.8821 1.29543C14.0247 1.62372 13.2884 2.20824 12.773 2.96994C12.2575 3.73163 11.9877 4.63376 12 5.55431V6.55744C10.2426 6.60315 8.50127 6.21218 6.93101 5.41933C5.36074 4.62648 4.01032 3.45638 3 2.01323C3 2.01323 -1 11.0415 8 15.054C5.94053 16.4564 3.48716 17.1595 1 17.0603C10 22.076 21 17.0603 21 5.52421C20.9991 5.24479 20.9723 4.96606 20.92 4.69161C21.9406 3.68194 22.6608 2.40717 23 1.01009V1.01009Z","stroke":"#1E3774","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

TwitterB.defaultProps = {"width":"24","height":"20","viewBox":"0 0 24 20","fill":"none"};

module.exports = TwitterB;

TwitterB.default = TwitterB;
